<div class="notifications-menu" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
  <h3 class="notifications-menu__title">Notifications</h3>

  <div class="notifications-menu__tabs">
    <div
      *ngIf="canReadCrm"
      class="notifications-menu__tab"
      [class.notifications-menu__tab--active]="activeTab === 'SONAR'"
      tabindex="0"
      (click)="changeTab($event, 'SONAR')"
      (keydown.enter)="changeTab($event, 'SONAR')">
      SONAR {{ canReadCrm && crmUnreaded !== null && rmsUnreaded !== null ? '(' + crmUnreaded + ')' : '' }}
    </div>
    <div
      class="notifications-menu__tab"
      [class.notifications-menu__tab--active]="activeTab === 'RMS'"
      tabindex="0"
      (click)="changeTab($event, 'RMS')"
      (keydown.enter)="changeTab($event, 'RMS')">
      RMS {{ canReadCrm && rmsUnreaded !== null && crmUnreaded !== null ? '(' + rmsUnreaded + ')' : '' }}
    </div>
  </div>

  <div class="notifications-menu__list">
    <ng-container *ngIf="loading">
      <rms-loading-spinner></rms-loading-spinner>
    </ng-container>

    <ng-container *ngIf="!loading">
      <div *ngIf="!notifications?.length" class="notifications-menu__empty">
        No Notifications
      </div>

      <ng-container *ngIf="notifications?.length">
        <div *ngFor="let notification of notifications" class="notifications-menu__item">
          <div class="notifications-menu__item-date">
            <span class="notifications-menu__item-date-bold">{{ notification.created | rmsTzFormat: undefined: 'MM/dd/yyyy' }}</span>
            | {{ notification.created | rmsTzFormat: undefined: 'hh:mma' }}
          </div>

          <div *ngIf="activeTab === 'RMS'" class="notifications-menu__item-description">
            {{ notification.notificationType?.description }}<span> - </span>
            <a
              class="notifications-menu__item-link"
              [routerLink]="['/company', notification.notifiableScopeTypeIdentifier]"
              target="_blank"
              (click)="onNotificationClick($event)">
              {{ notification.name }}
            </a>
          </div>

          <div
            *ngIf="activeTab === 'SONAR'"
            class="notifications-menu__item-description">
            {{ notification.customMessage }}
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div class="notifications-menu__actions">
    <a
      class="notifications-menu__see-all"
      [routerLink]="[linkPath]"
      [queryParams]="{ tab: activeTab }"
      queryParamsHandling="merge"
      target="_blank"
      (click)="onSeeAllClick($event)">
      See All {{ activeTab }} Notifications
    </a>
  </div>
</div>
